import { Controller } from '@hotwired/stimulus';

// "Add brand" sits inside the select's dropdown, which is a button rather than a link, so
// the frame is pointed at the form here instead of by a `data-turbo-frame` attribute.
export default class extends Controller {
  static values = { url: String, frame: String };

  add() {
    const frame = document.getElementById(this.frameValue);
    if (frame) frame.src = this.urlValue;
  }
}
